import script from "./MobilePass.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobilePass.vue?vue&type=script&lang=ts&setup=true"

import "./MobilePass.vue?vue&type=style&index=0&id=b1fa7308&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1fa7308"]])

export default __exports__